module.exports = __webpack_public_path__ + "img/up.57195f26.png";